import React from 'react';
import LoaderIcon from '../../assets/loader.svg';

export const Loader = ({ isLoading, isLoadingReg }: { isLoading: boolean; isLoadingReg?: boolean }) => {
  return (
    <React.Fragment>
      {(isLoading || isLoadingReg) && (
        <span
          className={'loader'}
          role="status"
          aria-live="polite"
          aria-label="Loading"
        >
          <LoaderIcon />
        </span>
      )}
    </React.Fragment>
  );
};
